var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditresume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80518 7.38965H6.80518C6.27474 7.38965 5.76603 7.60036 5.39096 7.97543C5.01589 8.35051 4.80518 8.85922 4.80518 9.38965L4.80518 18.3896C4.80518 18.9201 5.01589 19.4288 5.39096 19.8039C5.76603 20.1789 6.27474 20.3896 6.80518 20.3896H15.8052C16.3356 20.3896 16.8443 20.1789 17.2194 19.8039C17.5945 19.4288 17.8052 18.9201 17.8052 18.3896V17.3896",
    stroke: "#4C5966",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8052 5.38976L19.8052 8.38976M21.1902 6.97476C21.584 6.58091 21.8053 6.04674 21.8053 5.48976C21.8053 4.93277 21.584 4.3986 21.1902 4.00476C20.7963 3.61091 20.2622 3.38965 19.7052 3.38965C19.1482 3.38965 18.614 3.61091 18.2202 4.00476L9.80518 12.3898V15.3898H12.8052L21.1902 6.97476Z",
    stroke: "#4C5966",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditresume);
export default __webpack_public_path__ + "static/media/editresume.4aa4ab788c88ba360cfd1bb0b20e2f56.svg";
export { ForwardRef as ReactComponent };